import freeToolsApi from '@/api/freeTools';

const defaultState = () => ({
	freeToolsResult: [],
	notInFreeTools: [],
	product: [],
	freeToolsPagination: '',
	responSukses: '',
	errorResponse: {},
	alert: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	listFreeTools(state, data) {
		state.freeToolsResult = data.data
		state.freeToolsPagination = data.pagination;
	},
	listProductNotInFreetools (state, data) {
		state.notInFreeTools = data
	},
	listProduct (state, data) {
		state.product = data
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.errorResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.errorResponse = data;
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataFreeTools(state){
		Object.assign(state, defaultState())
	}
};

const actions = {
	getFreeTools({ commit, dispatch }, params) {
		freeToolsApi.getDataFreeTools(params).then(({ data: { data } }) => {
			commit('listFreeTools', { data: data.results, pagination: data.pagination } );
		}).catch( err => {
			const data = err.response.data
			commit('listFreeTools', { data: [], pagination: {} } );
			dispatch("errorHandler", data);
		});
	},
	async exportFreeTools({ dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await freeToolsApi.exportFreeTools(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async optionProductInFreetools({ commit, dispatch }) {
		await freeToolsApi.optionProductInFreetools().then(({ data: { data } }) => {
			commit('listProductNotInFreetools', data.results );
		}).catch( err => {
			const data = err.response.data
			commit('listProductNotInFreetools', { data: [], pagination: {} } );
			dispatch("errorHandler", data);
		});
	},
	async optionProduct({ commit, dispatch }) {
		await freeToolsApi.optionProduct().then(({ data: { data } }) => {
			commit('listProduct', data.results );
		}).catch( err => {
			const data = err.response.data
			commit('listProduct', { data: [], pagination: {} } );
			dispatch("errorHandler", data);
		});
	},
	async addFreeTools({ commit , dispatch},value) {
		await freeToolsApi.addFreeTools(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
	},
	async updateFreeTools({ commit , dispatch},value) {
		await freeToolsApi.updateFreeTools(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
	},
	async deleteFreeTools({ commit , dispatch},value) {
		await freeToolsApi.deleteFreeTools(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
	},
	errorHandler({ commit }, response) {
		commit("konfirmasiSukses", '');
		switch (response.message) {
			case 'error_validation':
			commit('saveConfirmResponse', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};